module.exports = __webpack_public_path__ + "img/banner_text_2.23d28d85.png";